module.exports = __webpack_public_path__ + "img/espa_el.ff2941fe.jpg";